import { IAGender } from './types/IAGender';
import { ScanDataGenre } from 'modules/ia/models/ScanDataGenre';
import { Nullable } from 'utils/types/Nullable/types';

export const mapGenre = (source: Nullable<IAGender>): Nullable<ScanDataGenre> => {
  if (source === 'M') return 'H';
  if (source === 'F') return 'M';
  return null;
};
